import React, { FC } from 'react';
import useTranslations from '@hooks/useTranslations';
import { TitleProps } from '@components/SummaryTitle/index';
import { usePersonalizedOffer } from '@hooks/usePersonalizedOffer';
import { useUserDuck } from '@hooks/useUserDuck';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';

const SummaryTitleTemplate: FC<TitleProps> = ({ className, isBasket }) => {
    const { t } = useTranslations();

    const { isUserLoggedInAsDealer } = useUserDuck();

    const { carDetails } = useCarDetailsDuck();

    const { isPersonalizedDeal } = usePersonalizedOffer();

    const isDemoVehicle = carDetails?.mileage && carDetails?.registrationDate;

    const getBasketTitleByLoggedInTypeOrDealType = () => {
        if (isUserLoggedInAsDealer) {
            return 'basket.vehicle.title.dealer';
        }

        if (isPersonalizedDeal) {
            return 'basket.vehicle.title.offer';
        }

        return 'basket.vehicle.title';
    };

    const getBasketDescriptionByLoggedInTypeOrDealType = () => {
        if (isUserLoggedInAsDealer) {
            return 'basket.vehicle.description.dealer';
        }

        if (isPersonalizedDeal) {
            return 'basket.vehicle.description.offer';
        }

        if (isDemoVehicle) {
            return 'basket.vehicle.description.demo';
        }

        return 'basket.vehicle.description';
    };

    return (
        <div className={className}>
            <h3>{isBasket ? t(getBasketTitleByLoggedInTypeOrDealType()) : t('summary.vehicle.title')}</h3>
            <p>{isBasket ? t(getBasketDescriptionByLoggedInTypeOrDealType()) : t('summary.vehicle.description')}</p>
        </div>
    );
};

export default SummaryTitleTemplate;
